import styles from "./home.module.css";
import GitHubCalendar from "react-github-calendar";
import "./home.css";
import pdf from "./Rahul Y H_Resume.pdf";
import { Loader } from "./loader";

function Home() {
  function handleResume() {
    window.open(
      `https://drive.google.com/file/d/1W2DmkFvCEetMLkmDoZ4dsxni9dAa_nqw/view?usp=share_link`,
      "_blank"
    );
  }

  return (
    <div className="home-main-main">
      <div className={`${styles.main} ${"nav-link home"}`} id="home1">
        <div id="about-1"></div>

        <img
          src="https://avatars.githubusercontent.com/u/110051547?v=4"
          alt="RAhulyh010"
          className={`styles.img1 ${"ball"} `}
        />
        <h1
          style={{ color: "#06082f" }}
          className="user-detail-name"
          id="user-detail-name"
        >
          Hi, I am Rahul Y H
        </h1>
        <h1 className="h1-style" align="center">
          {" "}
          <img
            src="https://readme-typing-svg.demolab.com/?font=Fira+Code&size=24&duration=4000&pause=1000&color=blue&background=FFFFFF00&width=500&height=51&lines=Full+Stack+Web+Developer;Rising+Mern+Developer;Always+Learning+New+Things"
            alt="Typing SVG"
          />
        </h1>
        <h4 style={{ color: "#06082f" }} className="stack-dev">
          I'm Full Stack Web Developer Always enthusiastic to learn and would
          love to work on new technologies.
        </h4>
      </div>

      <div id="about1"></div>

      <div id="about-1"></div>

      <div className="nav-link about">
        <h1 className="about-me">All About Me</h1>
        <div>
          <img
            className={`${styles.img2} ${"home-img"} `}
            align="center"
            alt="coding"
            src="https://camo.githubusercontent.com/3997f3b27a68e19c31e2d1c378d77303735faa42e7d18a8018f7510d66aaa83e/68747470733a2f2f7777772e77696e677374656368736f6c7574696f6e732e636f6d2f77702d636f6e74656e742f75706c6f6164732f323032322f30332f66756c6c2d737461636b2d646576656c6f706d656e742e676966"
          ></img>
        </div>

        <div id="user-detail-intro" className="user-detail-intro">
          Aspiring Full Stack Web Developer enthusiastic to learn and explore
          new technologies. 1200+ hours of practical experience building
          numerous websites and applications.Using MERN stack,
          JavaScript,MongoDB, React,HTML,CSS Solved more than 800
          data structure questions. Strongly interested in obtaining a Full
          Stack Web developer Or A React developer position to create impactful
          and scalable products.
        </div>

        <a href={pdf} download target="_blank" rel="noreferrer">
          <button id="resume-btn" onClick={handleResume}>
            Resume
          </button>
        </a>
      </div>
      <div id="skills1"></div>
      <div id="about-1"></div>

      <h1 className="skill-set">Skill Set</h1>

      <div className="nav-link skills" id="main2">
        <div className="skills-card">
          <img src="" alt="" className="skills-card-img" />
          <p className="skills-card-name"> 2000+ hrs coding</p>
        </div>
        <div className="skills-card">
          <img src="" alt="" className="skills-card-img" />
          <p className="skills-card-name"> 400+ hrs DSA Problem Solving</p>
        </div>
        <div className="skills-card">
          <img src="" alt="" className="skills-card-img" />
          <p className="skills-card-name"> 100+ hrs Soft Skills</p>
        </div>

        <div className="skills-card">
          <img src="" alt="" className="skills-card-img" />
          <p className="skills-card-name"> 500+ Git Commits</p>
        </div>
        <div className="skills-card">
          <img src="" alt="" className="skills-card-img" />
          <p className="skills-card-name"> 2+ Collaborative Projects</p>
        </div>
        <div className="skills-card">
          <img src="" alt="" className="skills-card-img" />
          <p className="skills-card-name"> 4 + Individual Projects</p>
        </div>
      </div>

      <h1 id="tech-stack">Tech Stack</h1>

      <div className={styles.main3} id="tech1">
        <div>
          <img
            src="https://mayurisamanta.github.io/Assets/icons/js.png"
            alt=""
          />
          <p>JavaScript</p>
        </div>
        <div>
          <img
            src="https://mayurisamanta.github.io/Assets/icons/html.png"
            alt=""
          />
          <p>HTML5</p>
        </div>
        <div>
          <img
            src="https://mayurisamanta.github.io/Assets/icons/css.png"
            alt=""
          />
          <p>CSS3</p>
        </div>
        <div>
          <img
            src="https://www.happylifecreators.com/wp/wp-content/uploads/2022/06/chakra-ui_title2-770x528.png"
            alt=""
          />
          <p>Chakra UI</p>
        </div>
        <div>
          <img
            src="https://mayurisamanta.github.io/Assets/icons/dsa.png"
            alt=""
          />
          <p>DSA</p>
        </div>
        <div>
          <img
            src="https://mayurisamanta.github.io/Assets/icons/restful.png"
            alt=""
          />
          <p>RestFull API's</p>
        </div>
        <div>
          <img
            src="https://mayurisamanta.github.io/Assets/icons/git.png"
            alt=""
          />
          <p>Github</p>
        </div>
        <div>
          <img
            src="https://mayurisamanta.github.io/Assets/icons/vscode.png"
            alt=""
          />
          <p>Vs Code</p>
        </div>
        <div>
          <img
            src="https://pbs.twimg.com/profile_images/446356636710363136/OYIaJ1KK_400x400.png"
            alt=""
          />
          <p>React</p>
        </div>
        <div>
          <img
            src="data:image/png;base64,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"
            alt=""
          />
          <p>Vercel</p>
        </div>
        <div>
          <img
            src="https://avatars.githubusercontent.com/u/44036562?s=280&v=4"
            alt=""
          />
          <p>Github actions</p>
        </div>
        <div>
          <img
            src="https://mayurisamanta.github.io/Assets/icons/netlify.png"
            alt=""
          />

          <p>Netlify</p>
        </div>
        <div>
          <img
            src="https://e7.pngegg.com/pngimages/828/432/png-clipart-npm-node-js-computer-icons-computer-software-installation-others-text-rectangle-thumbnail.png"
            alt=""
          />

          <p>NPM</p>
        </div>
        <div>
          <img
            width="70%"
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Node.js_logo.svg/590px-Node.js_logo.svg.png"
            alt=""
          />

          <p>Node.js</p>
        </div>
      </div>

      <h1 className="git-h1">My GitHub Stats</h1>
      <div className={styles.react} id="react1">
        <GitHubCalendar username="rahulyh010" id="github-cal" />
      </div>

      <div className="github-cards">
        <img
          width="48%"
          id="github-streak-stats"
          src="https://github-readme-streak-stats.herokuapp.com/?user=Rahulyh010&show_icons=true&theme=tokyonight&border_radius=10"
          alt=""
        />
        <img
          width="51%"
          id="github-stats-card"
          src="https://github-readme-stats.vercel.app/api?username=Rahulyh010&theme=tokyonight&border_radius=10"
          alt=""
        />
        <img
          width="48%"
          id="github-top-langs"
          src="https://github-readme-stats.vercel.app/api/top-langs/?username=Rahulyh010&theme=tokyonight&border_radius=10"
          alt=""
        />
      </div>

      <div id="projects11"></div>
      <div id="about-1"></div>

      <h1 className="project-h1">Some Of my Recent Projects</h1>

      <div className="nav-link projects" id="projects1">
        <div className="project-card">
          <div>
            <h3 className="project-title">Captain America Game</h3>
            <p className="project-description">
              This is game built during a hackathon in time span of two days,it
              was a team project and I was responsible for making game design
              and all the logic behind the game . Telling about the game, this
              is a running game where you have save yourself from fire comming
              towards you. this game also has a real-time chating feature and
              you can compete with your friend in real time on basis of score
              updating up . And it is honor to tell that we won 2 price for this
              game
            </p>
            <div id="min-tech-stack">
              Tech Stacks : HTML5 | CSS3 | TypeScript | React TS | Tail-Wind CSS | CSS Animations
            </div>
            <div className="p_btn">
              <a
                href="https://github.com/faisalinfinity/Game-Changers"
                className="project-github-link"
              >
                <img width="20%" src="" alt="" className="img-code" />
                <button className="code">Code</button>
              </a>
              <a
                href="https://captainamerica.vercel.app/"
                className="project-deployed-link"
              >
                <button className="code1">Live</button>
              </a>
            </div>
          </div>

          <div id="pro-sec-div">
            <img
              src="https://raw.githubusercontent.com/Rahulyh010/Rahulyh010.github.io/fc9d4f09109c6436c124946a00431f76684aa668/public/assets/Screenshot%20(177).png"
              alt="hello"
            />
          </div>
        </div>
        {/*  */}
        <div className="project-card">
          <div>
            <h3 className="project-title">India-Mart</h3>
            <p className="project-description">
              India-Mart is E-commcerce Website were can buy daily products food products brevages,
              and many more . This is collaborative Project built during the costruct week in the time span of 4 days,
              The tech stacks used in this project are HTML5,CSS3,JavaScript,React JS ,Node JS, Express,Mongoose,MongoDB,
              and many more ,and tools like vs Code,Github,vercel,cyclic. 
            </p>
            <div id="min-tech-stack">
              Tech Stacks : Mongoose | MongoDB | Express | HTML5 | CSS3 | JavaScript | React JS | Redux  
            </div>
            <div className="p_btn">
              <a href="https://github.com/Rahulyh010/spiffy-statement-5659" className="project-github-link" target="_blank" rel="noreferrer">
                <img
                  width="20%"
                  src="https://github.githubassets.com/images/modules/open_graph/github-octocat.png"
                  alt=""
                  className="img-code"
                />{" "}
                <button className="code">Code</button>
              </a>
              <a
                href="https://india-mart-rahulyh010.vercel.app/"
                className="project-deployed-link"
                target="_blank" rel="noreferrer"
              >
                <button className="code1">Live</button>
              </a>
            </div>
          </div>
          <div>
            <img
              src="https://user-images.githubusercontent.com/107460051/229421756-44d93e36-18b7-463d-82a9-c488596654e5.jpeg"
              alt=""
            />
          </div>
        </div>
        <div className="project-card">
          <div>
            <h3 className="project-title">Trend</h3>
            <p className="project-description">
             Trend is E-commerce wesite which Sells Clothes, Trending fashion and many more 
             This is collaborative Project built during the costruct week in the time span of 4 days,
              The tech stacks used in this project are HTML5,CSS3,JavaScript,React JS ,Redux,Redux-thunk,Context-api
              and many more ,and tools like vs Code,Github,vercel,cyclic.  
            </p>
            <div id="min-tech-stack">
              Tech Stacks : HTML5 | CSS3 | JavaScript | React JS | Redux
            </div>
            <div className="p_btn">
              <a href="https://github.com/Rahulyh010/hollow-idea-9446" className="project-github-link" target="_blank" rel="noreferrer">
                <img
                  width="20%"
                  src="https://github.githubassets.com/images/modules/open_graph/github-octocat.png"
                  alt=""
                  className="img-code"
                />{" "}
                <button className="code">Code</button>
              </a>
              <a
                href="https://n-eight-kappa.vercel.app/"
                className="project-deployed-link"
                target="_blank" rel="noreferrer"
              >
                <button className="code1">Live</button>
              </a>
            </div>
          </div>
          <div>
            <img
              src="https://user-images.githubusercontent.com/107553043/230719774-2786d0d2-f4ce-456f-91f5-6eff778237f3.png"
              alt=""
            />
          </div>
        </div>
        <div className="project-card">
          <div>
            <h3 className="project-title">KFC</h3>
            <p className="project-description">
              KFC is an American fast food restaurant chain headquartered in
              Louisville, Kentucky, that specializes in fried chicken. It is the
              world's second-largest restaurant chain after McDonald's, with
              22,621 locations globally in 150 countries as of December 2019.
              The chain is a subsidiary of Yum!
            </p>
            <div id="min-tech-stack">
              Tech Stacks : HTML5 | CSS3 | JavaScript | React JS | Redux | Chakra UI
            </div>
            <div className="p_btn">
              <a
                href="https://github.com/Rahulyh010/-flaky-drawer-7456/tree/main/rfc"
                className="project-github-link"
                target="_blank" rel="noreferrer"
              >
                <img
                  width="20%"
                  src="https://github.githubassets.com/images/modules/open_graph/github-octocat.png"
                  alt=""
                  className="img-code"
                />{" "}
                <button className="code">Code</button>
              </a>
              <a
                href="https://rfc-rahulyh010.vercel.app/"
                className="project-deployed-link"
                target="_blank" rel="noreferrer"
              >
                <button className="code1">Live</button>
              </a>
            </div>
          </div>
          <div>
            <img
              src="https://raw.githubusercontent.com/Rahulyh010/Rahulyh010.github.io/master/public/assets/Screenshot%20(121).png"
              alt=""
            />
          </div>
        </div>

        <div className="project-card">
          <div>
            <h3 className="project-title">Airtable Clone</h3>
            <p className="project-description">
              In short, Airtable is a platform that makes it easy to build
              powerful, custom applications. These tools can streamline just
              about any process, workflow, or project—and best of all, you can
              build them without ever learning to write a single line of code.
            </p>
            <div id="min-tech-stack">
              Tech Stacks : HTML5 | CSS3 | JavaScript 
            </div>
            <div className="p_btn">
              <a
                href="https://github.com/Rahulyh010/daily-wrist-2042"
                className="project-github-link"
                target="_blank" rel="noreferrer"
              >
                <img
                  width="20%"
                  src="https://github.githubassets.com/images/modules/open_graph/github-octocat.png"
                  alt=""
                  className="img-code"
                />{" "}
                <button className="code">Code</button>
              </a>
              <a
                href="https://sky-table-rahulyh010.vercel.app/"
                className="project-deployed-link"
                target="_blank" rel="noreferrer"
              >
                <button className="code1">Live</button>
              </a>
            </div>
          </div>

          <div>
            <img
              src="https://github.com/Rahulyh010/Rahulyh010.github.io/blob/master/public/assets/Screenshot%20(119).png?raw=true"
              alt="hello"
            />
          </div>
        </div>
      </div>

      <h1 id="contact-h2">Contact</h1>

      <div className="nav-link contact" id="contact1">
        <div id="contact-phone">
          <h2>Contact</h2>

          <a href="tel:7204524901">
            <img
              src="https://mayurisamanta.github.io/Assets/icons/call.gif"
              alt="Ph.no"
            />
          </a>
          <a href="tel:7204524901">
            <h2 id="hello">PH.NO +917204524901</h2>
          </a>
        </div>

        <div id="contact-email">
          {/*  */}
          <h2>Gmail</h2>
          <a href="mailto:rahulyh63@gmail.com" target="_blank" rel="noreferrer">
            <img
              src="https://mayurisamanta.github.io/Assets/icons/email.gif"
              alt="Ph.no"
            />
          </a>

          <h2>rahulyh@63gmail.com</h2>
        </div>

        <div id="contact-linkedin">
          {/* https://mayurisamanta.github.io/Assets/icons/icons8-linkedin-circled.gif */}
          <h2>Linked.in</h2>
          <a
            href="https://www.linkedin.com/in/rahul-y-h-b44556249/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://mayurisamanta.github.io/Assets/icons/icons8-linkedin-circled.gif "
              alt="Ph.no"
            />
          </a>
          <h2>Rahul Y H</h2>
        </div>

        <div>
          <h2>Github</h2>
          <a
            href="https://github.com/Rahulyh010"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://mayurisamanta.github.io/Assets/icons/icons8-github.gif"
              alt=""
            />
          </a>
          <h2>Rahulyh010</h2>
        </div>
      </div>

      <h1 className="h1-rahul">Made By Rahul</h1>
    </div>
  );
}

export default Home;
